import React from 'react';
import { css, cx } from 'emotion';
import insyncLogo from '../../assets/insync-logo.webp';
import insyncLogoPng from '../../assets/insync-logo.png';

const mainHeaderWrapper = css`
  grid-area: header;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid var(--primaryBrand);
  box-sizing: border-box;
  height: 5rem;
`;

const mainHeaderStyle = css`
  display: flex;
  position: relative;
  align-items: center;
  width: 60%;
  justify-content: space-between;
  padding-inline: 2rem;

  @media (max-width: 768px) {
    width: 100%;
    padding-inline: 1rem;
  }
`;

const logoStyle = css`
  display: block;
  height: 3.25rem;

  @media (max-width: 768px) {
    height: 2.75rem;
  }
`;

const imgStyle = css`
  height: 100%;
`;

const contactStyle = css`
  color: var(--dark);
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: color 0.2s;

  @media (max-width: 768px) {
    font-size: 0.875rem;
    gap: 0.25rem;
  }
`;

const phoneStyle = css`
  font-weight: 600;
  text-decoration: none;
  color: var(--primaryBrand);
`;

export const Header = () => (
  <header className={mainHeaderWrapper}>
    <div className={mainHeaderStyle}>
      <a href="https://insyncinsurance.co.uk/">
        <picture className={logoStyle}>
          <source srcSet={insyncLogo} type="image/webp" />
          <source srcSet={insyncLogoPng} type="image/png" />
          <img className={cx(imgStyle, 'keep-color')} src={insyncLogoPng} alt="Insync Logo!" />
        </picture>
      </a>
      <p className={contactStyle}>
        Need Help?
        <a href="tel:01200 309 516" target="_blank" rel="noopener noreferrer" className={phoneStyle}>
          01200 309 516
        </a>
      </p>
    </div>
  </header>
);
